import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  reset: {
    textTransform: 'unset',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 400,
    },
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
}));

export const ResetAnswer = ({ handleReset }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Typography
      variant="button"
      onClick={handleReset}
      onKeyDown={handleReset}
      role="button"
      tabIndex="0"
      color="primary"
      className={classes.reset}
    >
      {t('reset_answer.reset')}
    </Typography>
  );
};

ResetAnswer.propTypes = {
  handleReset: PropTypes.func.isRequired,
};
